export default __webpack_public_path__ + "static/media/4-1.7875facd.png";